module.exports = __webpack_public_path__ + "static/img/jhg_detail3.66775a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jhg_detail3.png
// module id = Wv/S
// module chunks = 0